import React from 'react';
import p1 from '../../assets/revs/p001.webp';
import p2 from '../../assets/revs/p002.webp';
import p3 from '../../assets/revs/p003.webp';

const About = () => {
  return (
    <section id='about'>
      <div className='container'>
        <div className='s-48'></div>
        <h3 className='title-sub tc'>
          IT-Weiterbildung für Quereinsteiger—mit echtem Karriereergebnis
        </h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma tc'>
          Nach Ihrer IT-Umschulung unterstützen wir Sie beim Einstieg in die IT-Branche!
        </h4>
        <div className='s-48'></div>
        <div className='reviews bg-lpink'>
          <div className='row'>
            <div className='col-lg-7'>
              <div className='card-review first bg-white flex aifs p-4'>
                <img src={p1} alt='Natasha' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Natalia</h4>
                  <p style={{ minHeight: 40, paddingTop: 7 }}>
                    Hallo! 
                    Ich kam als Flüchtling nach Deutschland und hatte keinen IT-Hintergrund. Nach Abschluss des Vibe-Coding-Kurses
                    bin ich erfolgreich in eine Tech-Karriere gewechselt. Der KI-unterstützte Ansatz machte Programmierung zugänglich,
                    auch ohne Vorerfahrung. Jetzt arbeite ich als Junior-Entwicklerin und kann meine Familie unterstützen. Vielen Dank für diese lebensverändernde Gelegenheit!
                  </p>
                </div>
              </div>
              <div className='s-24'></div>
              <div className='card-review second bg-white flex aifs p-4'>
                <img src={p2} alt='Snejana' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Snezhana</h4>
                  <p>
                    Vielen Dank! Ich konnte über ein Jahr lang keine Arbeit finden nach meiner Ankunft in Deutschland, aber dann
                    habe ich mich in DevOps mit KI-unterstützter Entwicklung umgeschult und innerhalb von sechs Wochen einen Job gefunden! Der Kurs lehrte mich, wie man KI-Tools
                    für schnelleres Lernen und Problemlösung nutzt. Das war eine erstaunliche Erfahrung - vielen Dank für alles und ich wünsche allen zukünftigen Studenten Erfolg!
                  </p>
                </div>
              </div>
              <div className='s-24 d-none-d-sm-block'></div>
            </div>
            <div className='col-lg-5'>
              <div className='card-review third bg-white flex aifs p-4'>
                <img src={p3} alt='Youri' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Ingrid</h4>
                  <div className='s-10'></div>
                  <p style={{ paddingRight: 18 }}>
                    Diese Kurse haben mein Leben völlig verändert!
                    Ich arbeitete in einem schwierigen Beruf und wollte einen neuen Weg finden. Die KI-unterstützten Videoproduktions- und Digital-Design-Kurse waren perfekt für jemanden wie mich.
                    Jetzt arbeite ich in der Werbebranche und erstelle überzeugende Videoinhalte und digitale Kampagnen mit KI-Tools.
                    Der Übergang war reibungsloser als ich je gedacht hätte!
                    <br />
                    Mein Rat an zukünftige Studenten: Haben Sie keine Angst vor einem kompletten Karrierewechsel. Diese Fähigkeiten öffnen Türen zu kreativen Branchen, die Sie nie für möglich gehalten hätten.
                    Ich ging von einer herausfordernden Situation zur Arbeit mit Top-Werbeagenturen in Berlin. Die KI-Tools machen alles erreichbar!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='s-48'></div>
      </div>
    </section>
  );
};

export { About };